module.exports = __webpack_public_path__ + "img/section_bg_bottom_a.bc21c00e.png";